import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';
import ModuleBundle from 'src/config/models/ModuleBundle';

export const UserWiseReportModule = new Module({
  id: 'USER_WISE_REPORT:VIEW:*',
  name: 'User-Wise Report',
  label: 'User-Wise Report',
  path: 'user-wise',
  Component: ComponentLoader(
    lazy(() => import('src/content/reports/SessionReport/UserWiseReport'))
  ),
  actions: {
    exportData: {
      id: 'USER_WISE_REPORT:ACTION:EXPORT_DATA',
      name: 'export-data',
      label: 'Export Data'
    }
  }
});

const UserWiseReportModules = [UserWiseReportModule];

export default new ModuleBundle('UserWiseReport', UserWiseReportModules);
